// extracted by mini-css-extract-plugin
export default {"counter":"SearchPosition_counter__++LU0","button":"SearchPosition_button__el4CI","iconUp":"SearchPosition_iconUp__m1OwD"};